import React from 'react';

const TABS = [
  { id: 'passwords', label: 'Passwords', icon: 'fa-solid fa-lock' },
  { id: 'cards', label: 'Cards', icon: 'fa-regular fa-credit-card' },
  { id: 'documents', label: 'Documents', icon: 'fa-regular fa-file-lines' },
];

const AppTabs = ({ activeTab, onTabChange }) => {
  return (
    <nav className="flex flex-wrap gap-2 mb-4" aria-label="Sections">
      {TABS.map((tab) => {
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={
              isActive
                ? 'inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium bg-orange-500 text-white'
                : 'inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium bg-white text-gray-900 border border-gray-300 hover:bg-gray-50'
            }
            aria-current={isActive ? 'page' : undefined}
          >
            <i className={tab.icon} />
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};

export default AppTabs;
